import React from 'react'

const IconInternet = (props) => {
  const {active} = props

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 48 48'>
      <g fill='none' stroke={`${active ? '#eeeeee' : '#00b9d5'}`} stroke-width='3'>
        <path stroke-linejoin='round' d='M3 24a21 21 0 1 0 42 0a21 21 0 1 0-42 0' />
        <path stroke-linejoin='round' d='M15 24a9 21 0 1 1 18 0a9 21 0 1 1-18 0' />
        <path stroke-linecap='round' d='M4.5 31h39m-39-14h39' />
      </g>
    </svg>
  )
}
export default IconInternet